import { useEffect, useState } from "react";
import Layout from "@/components/Layout";
import { api } from "@/lib/api";
import { BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer, LineChart, Line, CartesianGrid } from "recharts";
import { toast } from "sonner";

export default function StudentAnalytics() {
  const [stats, setStats] = useState(null);
  useEffect(() => {
    (async () => {
      try { const s = await api.get("/analytics/student"); setStats(s.data); }
      catch { toast.error("Failed to load analytics"); }
    })();
  }, []);
  if (!stats) return <Layout title="Analytics" subtitle="Learning insights"><div>Loading…</div></Layout>;

  const cards = [
    { label: "Courses", value: stats.courses_enrolled, color: "bg-blue-50 text-blue-700" },
    { label: "Certificates", value: stats.certificates, color: "bg-emerald-50 text-emerald-700" },
    { label: "Submissions", value: stats.submissions_count, color: "bg-violet-50 text-violet-700" },
    { label: "Attempts", value: stats.quiz_attempts, color: "bg-amber-50 text-amber-700" },
  ];

  return (
    <Layout title="Learning Analytics" subtitle="Student · Insights">
      <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-6">
        {cards.map((c) => (
          <div key={c.label} className={`rounded-2xl p-5 ${c.color}`}>
            <div className="font-display font-black text-3xl">{c.value}</div>
            <div className="text-xs uppercase tracking-[0.2em] mt-1">{c.label}</div>
          </div>
        ))}
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        <div className="bg-white border border-slate-200 rounded-2xl p-6">
          <h2 className="font-display font-bold text-lg text-slate-900 mb-4">Weekly activity</h2>
          <div className="h-64">
            <ResponsiveContainer>
              <LineChart data={stats.activity}>
                <CartesianGrid strokeDasharray="3 3" stroke="#E2E8F0" />
                <XAxis dataKey="week" stroke="#64748B" fontSize={12} />
                <YAxis stroke="#64748B" fontSize={12} />
                <Tooltip />
                <Line type="monotone" dataKey="lessons" stroke="#2563EB" strokeWidth={2.5} />
                <Line type="monotone" dataKey="quiz" stroke="#8B5CF6" strokeWidth={2.5} />
              </LineChart>
            </ResponsiveContainer>
          </div>
        </div>
        <div className="bg-white border border-slate-200 rounded-2xl p-6">
          <h2 className="font-display font-bold text-lg text-slate-900 mb-4">Performance snapshot</h2>
          <div className="h-64">
            <ResponsiveContainer>
              <BarChart data={[
                { name: "Attendance", value: stats.attendance_pct },
                { name: "Assignments", value: stats.avg_assignment_score },
                { name: "Quizzes", value: stats.avg_quiz_pct },
                { name: "Progress", value: stats.avg_progress },
              ]}>
                <CartesianGrid strokeDasharray="3 3" stroke="#E2E8F0" />
                <XAxis dataKey="name" stroke="#64748B" fontSize={12} />
                <YAxis stroke="#64748B" fontSize={12} domain={[0, 100]} />
                <Tooltip />
                <Bar dataKey="value" fill="#10B981" radius={[8, 8, 0, 0]} />
              </BarChart>
            </ResponsiveContainer>
          </div>
        </div>
      </div>
    </Layout>
  );
}
